import React, { useEffect } from "react";
import { styled } from "styled-components";
import { Colors } from "../../ColorConstants";

const ImageSlide = ({ imageArray, activeImgIndex,onImageSelect }) => {
  return (
    <ImagesSlideContainer>
      <ImagePreviewList>
        {imageArray?.map((img,index) => (
          <img src={img.url} alt={img.alt} onClick={()=>onImageSelect(index)}/>
        ))}
      </ImagePreviewList>
      <ActiveImagePreview>
        <img
          src={imageArray?.[activeImgIndex].url}
          alt={imageArray?.[activeImgIndex].alt}
        />
      </ActiveImagePreview>
    </ImagesSlideContainer>
  );
};

const ImagePreviewList = styled.div`
  width: 20%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 0.7rem;
  > img {
    width: 4rem;
    height: 4rem;
    border-radius: 0.5rem;
    object-fit: cover;
    cursor: pointer;
  }
`;

const ActiveImagePreview = styled.div`
  width: 80%;
  cursor: pointer;
  > img {
    width: 24rem;
    height: 18rem;
    object-fit: cover;
    border-radius: 0.5rem;
  }
`;

const ImagesSlideContainer = styled.div`
  width: 100%;
  display: flex;
  height: fit-content;
  @media only screen and (max-width: 1024px) {
    display: none;
  }
`;

export default ImageSlide;
